import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import AppProvider from 'providers/AppProvider';
import 'helpers/initFA';
import { router } from 'routes';
import './assets/font.css';

// 프로덕션 환경에서는 모든 console 출력 비활성화
if (process.env.NODE_ENV === 'production') {
  try {
    const noop = () => { };
    ['log', 'debug', 'info', 'warn', 'error'].forEach(method => {
      // eslint-disable-next-line no-console
      console[method] = noop;
    });
  } catch (e) {
    // no-op
  }
}

const container = document.getElementById('main');
const root = createRoot(container);

root.render(
  // <React.StrictMode>
  //   <AppProvider>
  //     <RouterProvider router={router} />
  //   </AppProvider>
  // </React.StrictMode>

  <AppProvider>
    <RouterProvider router={router} />
  </AppProvider>
);
